module.exports = __webpack_public_path__ + "img/sen.5b654e1a.svg";